// extracted by mini-css-extract-plugin
module.exports = {"form":"style_form__2oed_","nameRow":"style_nameRow__1s20Y","buttonContainer":"style_buttonContainer__3B35U"};